import hasWorkScheduleFeatures from '@/mixins/hasWorkScheduleFeatures';

export default {
  mixins: [hasWorkScheduleFeatures],

  methods: {
    showTimePairDeviation(timePair, isManager) {
      if ((isManager && !this.isWorkScheduleManagerViewFeatureEnabled)
        || (!isManager && !this.isWorkScheduleEmployeeViewFeatureEnabled)
      ) {
        return false;
      }
      return timePair.startingWorkScheduleDay != null && timePair.workScheduleMinuteDeviation !== 0;
    },
  },
};
